import { render } from "./BasicSettingsPage.vue?vue&type=template&id=b0296706"
import script from "./BasicSettingsPage.vue?vue&type=script&lang=js"
export * from "./BasicSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__